"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = require("underscore");

var _immutable = require("immutable");

var _OwnersStore = _interopRequireDefault(require("crm_data/owners/OwnersStore"));

var _DealStageStore = _interopRequireDefault(require("crm_data/deals/DealStageStore"));

var _DealPipelineStore = _interopRequireDefault(require("crm_data/deals/DealPipelineStore"));

var _TicketsPipelinesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStore"));

var _TicketsPipelinesStagesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStagesStore"));

var _SfdcCampaignsStore = _interopRequireDefault(require("crm_data/sfdc/SfdcCampaignsStore"));

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _PersonasStore = _interopRequireDefault(require("crm_data/properties/PersonasStore"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var FormatOwnerName = _interopRequireWildcard(require("customer-data-objects/owners/FormatOwnerName"));

var _ImportNamesStore = _interopRequireDefault(require("crm_data/imports/ImportNamesStore"));

var _TeamsStore = _interopRequireDefault(require("crm_data/teams/TeamsStore"));

var _CampaignsStore = _interopRequireDefault(require("crm_data/campaigns/CampaignsStore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var ExternalOptionTypes = _interopRequireWildcard(require("customer-data-objects/property/ExternalOptionTypes"));

var _guids = require("reporting-data/lib/guids");

var _isNumber = _interopRequireDefault(require("transmute/isNumber"));

var CONTACT = _ObjectTypes.default.CONTACT,
    DEAL = _ObjectTypes.default.DEAL,
    TICKET = _ObjectTypes.default.TICKET,
    COMPANY = _ObjectTypes.default.COMPANY;
var DATA_1 = 'hs_analytics_source_data_1';
var DATA_2 = 'hs_analytics_source_data_2';
var SOURCE = 'hs_analytics_source';
var PROSPECTS_DATA_1 = 'sourceData1';
var PROSPECTS_DATA_2 = 'sourceData2';

var isFromImport = function isFromImport(subject) {
  if (!subject) {
    return null;
  }

  var source = (0, _ImmutableModel.getProperty)(subject, SOURCE);
  var data1 = (0, _ImmutableModel.getProperty)(subject, DATA_1);
  return ['OFFLINE', 'IMPORTED'].includes(source) && data1 === 'IMPORT';
};

var campaignStoreConnection = {
  stores: [_CampaignsStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType,
        value = _ref.value;

    if (!value || objectType === DEAL) {
      return value;
    }

    var campaign = _CampaignsStore.default.get(value);

    if (!campaign) {
      return null;
    }

    var campaignLabel = campaign.get('display_name');
    return campaignLabel;
  }
};
var analyticsDataSource = {
  stores: [_ImportNamesStore.default],
  deref: function deref(_ref2) {
    var subject = _ref2.subject,
        value = _ref2.value;

    if (!value) {
      return null;
    } else if ((0, _guids.isKnownGuid)(value)) {
      return (0, _guids.getGuidLabel)(value);
    } else if (isFromImport(subject) && _ImportNamesStore.default.get(value)) {
      return _ImportNamesStore.default.get(value).get('importName');
    }

    return null;
  }
};
var CONNECTIONS_BY_REFERENCED_OBJECT_TYPE = {};
CONNECTIONS_BY_REFERENCED_OBJECT_TYPE[ExternalOptionTypes.OWNER] = {
  stores: [_OwnersStore.default],
  deref: function deref(_ref3) {
    var value = _ref3.value;

    if (!value || !(0, _isNumber.default)(+value)) {
      return null;
    }

    var owner = _OwnersStore.default.get(value);

    if (owner) {
      return FormatOwnerName.formatWithEmail(owner);
    }

    return null;
  }
};
CONNECTIONS_BY_REFERENCED_OBJECT_TYPE[ExternalOptionTypes.CAMPAIGN] = campaignStoreConnection;
var CONNECTIONS_BY_PROPERTY_NAME = {
  hubspot_team_id: {
    stores: [_TeamsStore.default],
    deref: function deref(_ref4) {
      var value = _ref4.value;

      if (!value) {
        return null;
      }

      var teams = _TeamsStore.default.get();

      if (teams) {
        return teams.getIn([String(value), 'name']);
      }

      return null;
    }
  },
  hubspot_owner_id: {
    stores: [_OwnersStore.default],
    deref: function deref(_ref5) {
      var value = _ref5.value;

      if (!value) {
        return null;
      }

      var owner = _OwnersStore.default.get(value);

      if (owner) {
        return FormatOwnerName.formatWithEmail(owner);
      }

      return null;
    }
  },
  dealstage: {
    stores: [_DealStageStore.default],
    deref: function deref(_ref6) {
      var objectType = _ref6.objectType,
          value = _ref6.value;

      if (!value) {
        return null;
      }

      if (objectType === DEAL) {
        return _DealStageStore.default && _DealStageStore.default.get(value) && _DealStageStore.default.get(value).get('text');
      }

      return null;
    }
  },
  pipeline: {
    stores: [_DealPipelineStore.default],
    deref: function deref(_ref7) {
      var objectType = _ref7.objectType,
          value = _ref7.value;

      if (!value) {
        return null;
      }

      if (objectType === DEAL) {
        return _DealPipelineStore.default.get() && _DealPipelineStore.default.get().getIn([value, 'label']);
      }

      return null;
    }
  },
  hs_pipeline: {
    stores: [_TicketsPipelinesStore.default],
    deref: function deref(_ref8) {
      var objectType = _ref8.objectType,
          value = _ref8.value;

      if (!value) {
        return null;
      }

      if (objectType === TICKET) {
        return _TicketsPipelinesStore.default.get() && _TicketsPipelinesStore.default.get().getIn([value, 'label']);
      }

      return null;
    }
  },
  hs_pipeline_stage: {
    stores: [_TicketsPipelinesStagesStore.default],
    deref: function deref(_ref9) {
      var objectType = _ref9.objectType,
          value = _ref9.value;

      if (!value) {
        return null;
      }

      if (objectType === TICKET) {
        return _TicketsPipelinesStagesStore.default.get() && _TicketsPipelinesStagesStore.default.get().getIn([value, 'label']);
      }

      return null;
    }
  },
  hs_parent_company_id: {
    stores: [_CompaniesStore.default],
    deref: function deref(_ref10) {
      var objectType = _ref10.objectType,
          value = _ref10.value;

      if (!value) {
        return null;
      }

      var company = _CompaniesStore.default.get(value);

      if (objectType === COMPANY && company) {
        return (0, _ImmutableModel.toString)(company);
      }

      return null;
    }
  },
  hs_persona: {
    stores: [_PersonasStore.default],
    deref: function deref(_ref11) {
      var objectType = _ref11.objectType,
          value = _ref11.value;

      if (!value) {
        return null;
      }

      if (objectType === CONTACT) {
        var personaId = parseInt(value.replace('persona_', ''), 10);

        var persona = _PersonasStore.default.get() && _PersonasStore.default.get().get(personaId);

        return persona && persona.name || value;
      }

      return null;
    }
  },
  salesforcecampaignids: {
    stores: [_SfdcCampaignsStore.default],
    deref: function deref(_ref12) {
      var objectType = _ref12.objectType,
          value = _ref12.value;

      if (!value) {
        return null;
      }

      if (objectType === CONTACT) {
        var ids = (0, _immutable.Seq)(value.split(';'));

        var campaigns = _SfdcCampaignsStore.default.get(ids);

        if (!campaigns) {
          return null;
        }

        campaigns = campaigns.map(function (campaign) {
          if (campaign == null) {
            return null;
          }

          return campaign.get('name') || campaign.get('id');
        }).filter(function (name) {
          return name;
        }).toList();

        if (campaigns.size) {
          return campaigns.join(', ');
        }
      }

      return null;
    }
  },
  hs_analytics_first_touch_converting_campaign: campaignStoreConnection,
  hs_analytics_last_touch_converting_campaign: campaignStoreConnection
};
CONNECTIONS_BY_PROPERTY_NAME[DATA_1] = analyticsDataSource;
CONNECTIONS_BY_PROPERTY_NAME[PROSPECTS_DATA_1] = analyticsDataSource;
CONNECTIONS_BY_PROPERTY_NAME[DATA_2] = analyticsDataSource;
CONNECTIONS_BY_PROPERTY_NAME[PROSPECTS_DATA_2] = analyticsDataSource;
var _default = {
  single: (0, _underscore.memoize)(function (propertyName, propertyReferencedObjectType) {
    var connection = CONNECTIONS_BY_PROPERTY_NAME[propertyName] || CONNECTIONS_BY_REFERENCED_OBJECT_TYPE[propertyReferencedObjectType] || undefined;

    if (!connection) {
      return null;
    }

    return {
      propTypes: {
        objectType: _ObjectTypesType.default.isRequired,
        subject: _SubjectType.default
      },
      stores: connection.stores,
      deref: connection.deref
    };
  }),
  all: (0, _underscore.once)(function () {
    var stores = _underscore.union.apply(null, (0, _underscore.pluck)(CONNECTIONS_BY_PROPERTY_NAME, 'stores'), (0, _underscore.pluck)(CONNECTIONS_BY_REFERENCED_OBJECT_TYPE, 'stores'));

    return {
      propTypes: {
        objectType: _ObjectTypesType.default.isRequired,
        subject: _SubjectType.default,
        propertyName: _propTypes.default.string.isRequired,
        propertyReferencedObjectType: _propTypes.default.string
      },
      stores: stores,
      deref: function deref(props) {
        var propertyName = props.propertyName,
            propertyReferencedObjectType = props.propertyReferencedObjectType;
        var connection = CONNECTIONS_BY_PROPERTY_NAME[propertyName] || CONNECTIONS_BY_REFERENCED_OBJECT_TYPE[propertyReferencedObjectType] || undefined;

        if (connection) {
          return connection.deref(props);
        }

        return null;
      }
    };
  })
};
exports.default = _default;
module.exports = exports.default;